import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ReceivableFinancingLimitModalSF from './ReceivableFinancingLimitModalSF.js'
import MinMonthlyCollectionModalSF from './MinMonthlyCollectionModalSF.js'
import LoanStructureSF from '../../../components/superUser/loan/LoanStructureSF.js'
import TermSheetNavUI from '../../../components/superUser/loan/TermSheetNavUI'
import AprCalculationUI from '../../../components/superUser/loan/AprCalculationUI'
import TermsUpdateSF from '../../../components/superUser/loan/TermsUpdateSF'
import { KvRowUI, KvSectionUI, KvSummaryUI } from '../../../widgets/layout/KvRowUI'
import './TermSheetPage.css'

const TermSheetPageUI = ({ context, errorList, loan, directorList, propertyList, onRefreshClick,
  apr, aprFormula,
  receivableFinancingLimitUpdateMode, onSetReceivableFinancingLimitClick, onSetReceivableFinancingLimitCancel,
  minMonthlyCollectionAmountUpdateMode, onSetMinMonthlyCollectionAmountClick, onSetMinMonthlyCollectionAmountCancel,
  termsUpdateMode, onTermsUpdateClick, onTermsUpdateCancel,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_ts'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !directorList || !propertyList} loan={loan} page='termSheet'
    dimension='w1600'
  >
    {
      (!loan || !errorList || !directorList || !propertyList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && directorList && propertyList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Term sheet</b></span>
            </span>
          }
          right={<span />}
        />

        <TermSheetNavUI loan={loan} tab='tokens' />

        <TokensTabUI
          context={context}
          loan={loan}
          directorList={directorList}
          propertyList={propertyList}
          apr={apr}
          aprFormula={aprFormula}
          onRefreshClick={onRefreshClick}
          onSetReceivableFinancingLimitClick={onSetReceivableFinancingLimitClick}
          onSetMinMonthlyCollectionAmountClick={onSetMinMonthlyCollectionAmountClick}
          onTermsUpdateClick={onTermsUpdateClick}
        />

        <TermsUpdateSF
          context={context}
          loan={loan}
          isOpen={termsUpdateMode}
          onCancelClick={onTermsUpdateCancel}
          onRefreshClick={onRefreshClick}
        />

        <ReceivableFinancingLimitModalSF
          context={context} loan={loan}
          updateMode={receivableFinancingLimitUpdateMode}
          onCancelClick={onSetReceivableFinancingLimitCancel}
          onRefreshClick={onRefreshClick}
        />

        <MinMonthlyCollectionModalSF
          context={context} loan={loan}
          updateMode={minMonthlyCollectionAmountUpdateMode}
          onCancelClick={onSetMinMonthlyCollectionAmountCancel}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }
  </SuperUserLoanPageUI>

const TokensTabUI = ({
  context, loan, directorList, propertyList, apr, aprFormula, onRefreshClick,
  onSetReceivableFinancingLimitClick, onSetMinMonthlyCollectionAmountClick,
  onTermsUpdateClick,
}) =>
  <div>
    <div className='ts_tokens_grid'>
      <div className='ts_tokens_grid_col'>
        <TermsUI context={context} loan={loan}
          onTermsUpdateClick={onTermsUpdateClick}
          onSetReceivableFinancingLimitClick={onSetReceivableFinancingLimitClick}
          onSetMinMonthlyCollectionAmountClick={onSetMinMonthlyCollectionAmountClick}
        />
      </div>
      <div className='ts_tokens_grid_col'>
        <LoanStructureSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          directorList={directorList} propertyList={propertyList} />
        <AprCalculationUI
          apr={apr}
          aprFormula={aprFormula}
          termSheetApr={loan.termSheet.apr}
        />
      </div>
    </div>
  </div>


const TermsUI = ({ loan, onTermsUpdateClick, onSetReceivableFinancingLimitClick,
  onSetMinMonthlyCollectionAmountClick }) => {
  const ts = loan.termSheet
  const isHybrid = loan.loanType === 'int_then_prj'
  const loanTenure = ts.loanTenureMonths
  const showLoanTenure = loanTenure != null && loanTenure !== ''
    && Number(loanTenure) !== Number(ts.tenureMonths)
  const hasMoratorium = loan.moratoriumPeriod || loan.moratoriumInterestRate
  const hasConstruction = loan.constructionPeriod || loan.constructionInterestRate
  const processingFee = ts.processingFeePercent != null && ts.processingFeePercent !== ''
    ? (ts.processingFeePercentF || `${ts.processingFeePercent}%`)
    : null
  const dsraLabel = (() => {
    if (!loan.sanction) return null
    const { dsraPercent, dsraAmountF2, dsraMonths } = loan.sanction
    if (dsraPercent != null && dsraPercent !== '') {
      return `${dsraPercent}%${dsraAmountF2 ? ` (${dsraAmountF2})` : ''}`
    }
    if (dsraMonths != null && dsraMonths !== '') {
      return `${dsraMonths} mo${dsraAmountF2 ? ` (${dsraAmountF2})` : ''}`
    }
    return null
  })()
  const additionalDsraLabel = (() => {
    if (!loan.sanction) return null
    const { additionalDsraPercent, additionalDsraMonths, additionalDsraDueDate } = loan.sanction
    const parts = []
    if (additionalDsraPercent) parts.push(`${additionalDsraPercent}%`)
    else if (additionalDsraMonths) parts.push(`${additionalDsraMonths} mo`)
    if (additionalDsraDueDate) parts.push(`due ${additionalDsraDueDate}`)
    return parts.length ? parts.join(' · ') : null
  })()
  const dsraReleaseLabel = loan.sanction && loan.sanction.dsraReleaseAmountF2
    ? loan.sanction.dsraReleaseAmountF2
    : null
  const phaseLabel = (period, rate, postRate) => {
    const parts = []
    if (period) parts.push(`${period} mo`)
    if (rate != null && rate !== '') parts.push(`@ ${rate}%`)
    let label = parts.join(' ') || '—'
    if (postRate != null && postRate !== '') label += ` → then ${postRate}%`
    return label
  }

  return (
    <CardUI title={
      <div className='g_flex_h'>
        <span>Loan terms</span>
        <span className='g_link' onClick={onTermsUpdateClick}>
          Edit terms →
        </span>
      </div>
    }>
      <KvSummaryUI items={[
        { label: 'Amount', value: ts.amountF2 },
        { label: 'Interest rate', value: `${ts.interestRate}%` },
      ]} />

      <KvSectionUI label='Product' />
      <KvRowUI label='Loan type' value={
        loan.loanType === 'project' ? 'Amortized'
          : loan.loanType === 'interest_only' ? 'Interest only'
            : loan.loanType === 'int_then_prj' ? 'Hybrid'
              : loan.loanType === 'inv_discount' ? 'Receivable financing'
                : loan.loanType === 'lease' ? 'Lease' : '—'
      } />
      <KvRowUI label='Loan sub type' value={
        loan.loanSubType === 'standard' ? 'Standard'
          : loan.loanSubType === 'epc' ? 'EPC'
            : loan.loanSubType === 'ppa' ? 'PPA'
              : loan.loanSubType === 'co_borrower' ? 'Co-borrower'
                : loan.loanSubType === 'nbfc' ? 'NBFC (Others)'
                  : loan.loanSubType === 'nbfc_vehicle' ? 'NBFC Vehicle'
                    : loan.loanSubType === 'venture_fund' ? 'Venture Fund'
                      : loan.loanSubType === 'vehicle_loan' ? 'Vehicle Loan'
                        : loan.loanSubType === 'vehicle' ? 'Vehicle Lease'
                          : loan.loanSubType === 'inv_discount' ? 'Receivable financing'
                            : '—'
      } />
      {
        loan.followUpLoan &&
        <KvRowUI label='Follow-up loan' value='Yes' />
      }
      {
        loan.loanRequest && (loan.loanRequest.amountF2 || loan.loanRequest.tenureMonths) &&
        <KvRowUI label='Borrower requested' value={
          [
            loan.loanRequest.amountF2,
            loan.loanRequest.tenureMonths ? `${loan.loanRequest.tenureMonths} mo` : null,
          ].filter(Boolean).join(' · ') || '—'
        } />
      }

      <KvSectionUI label='Tenure' />
      {
        isHybrid && ts.interestMonths
          ? <KvRowUI label='Structure'
            value={`${ts.interestMonths} mo interest only → ${ts.tenureMonths} mo amortized`} />
          : <>
            <KvRowUI label='Amortized / interest tenure' value={`${ts.tenureMonths} months`} />
            {
              ts.interestMonths && !isHybrid &&
              <KvRowUI label='Interest only tenure' value={`${ts.interestMonths} months`} />
            }
          </>
      }
      {
        showLoanTenure &&
        <KvRowUI label='Loan tenure (shorter)' value={`${loanTenure} months`} />
      }

      <KvSectionUI label='Fees & project' />
      {processingFee && <KvRowUI label='Processing fee' value={processingFee} />}
      {dsraLabel && <KvRowUI label='DSRA' value={dsraLabel} />}
      <KvRowUI label='Additional DSRA' value={additionalDsraLabel || '—'} />
      <KvRowUI label='DSRA release' value={dsraReleaseLabel || '—'} />
      {loan.sanction && loan.sanction.promoterFundF3 && <KvRowUI label='Promoter contribution' value={loan.sanction.promoterFundF3} />}
      {loan.projectTotalF3 && <KvRowUI label='Total project cost' value={loan.projectTotalF3} />}

      {
        (hasMoratorium || hasConstruction) &&
        <>
          <KvSectionUI label='Phases' />
          {hasMoratorium && <KvRowUI label='Moratorium' value={
            phaseLabel(loan.moratoriumPeriod, loan.moratoriumInterestRate, loan.postMoratoriumInterestRate)
          } />}
          {hasConstruction && <KvRowUI label='Construction' value={
            phaseLabel(loan.constructionPeriod, loan.constructionInterestRate, loan.postConstructionInterestRate)
          } />}
        </>
      }

      <KvSectionUI label='Limits' />
      <KvRowUI label='Receivable financing limit' value={loan.account.limitF2 || '—'}
        onEdit={onSetReceivableFinancingLimitClick} />
      <KvRowUI label='Minimum monthly collection' value={loan.minMonthlyCollectionAmountF2 || '—'}
        onEdit={onSetMinMonthlyCollectionAmountClick} />
    </CardUI>
  )
}

export default TermSheetPageUI
